import { createContext, useCallback, useContext, useEffect, useState } from "react";

const SiteCtx = createContext(null);

export function SiteProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem("sepla-enquiry") || "[]"); } catch { return []; }
  });
  const [panelOpen, setPanelOpen] = useState(false);
  const [flies, setFlies] = useState([]);

  useEffect(() => { localStorage.setItem("sepla-enquiry", JSON.stringify(items)); }, [items]);

  const add = useCallback((product, qty = 1, variantCode = null) => {
    const code = variantCode || product.code;
    const name = variantCode && product.variants?.length
      ? `${product.name} ${product.variants.find((v) => v.code === variantCode)?.size || ""}`.trim()
      : product.name;
    setItems((list) => {
      const found = list.find((i) => i.code === code);
      if (found) return list.map((i) => (i.code === code ? { ...i, qty: i.qty + qty } : i));
      return [...list, { code, name, image: product.image, qty }];
    });
  }, []);

  const setQty = useCallback((code, qty) => {
    setItems((list) => (qty <= 0 ? list.filter((i) => i.code !== code) : list.map((i) => (i.code === code ? { ...i, qty } : i))));
  }, []);

  const removeItem = useCallback((code) => setItems((list) => list.filter((i) => i.code !== code)), []);
  const clear = useCallback(() => setItems([]), []);

  // fly-to-enquiry animation bus
  const fly = useCallback((imgEl, src) => {
    if (!imgEl) return;
    const target = document.getElementById("enquiry-nav-btn");
    if (!target) return;
    const from = imgEl.getBoundingClientRect();
    const to = target.getBoundingClientRect();
    const id = Math.random().toString(36).slice(2);
    setFlies((f) => [...f, { id, src, from: { x: from.left, y: from.top, w: from.width, h: from.height }, to: { x: to.left + to.width / 2, y: to.top + to.height / 2 } }]);
    setTimeout(() => setFlies((f) => f.filter((x) => x.id !== id)), 900);
  }, []);

  const count = items.reduce((n, i) => n + i.qty, 0);

  return (
    <SiteCtx.Provider value={{ items, add, setQty, removeItem, clear, count, panelOpen, setPanelOpen, flies, fly }}>
      {children}
    </SiteCtx.Provider>
  );
}

export const useSite = () => useContext(SiteCtx);
